<apc-multi-forms [forms]="forms" (addTitleToCollapsableEvent)="addTitleToCollapsable(forms)"
    [newEmptyForm]="initNewForm" [newDataForm]="initForm" [getData]="budgetService.getBudgets"
    [getDataSearch]="budgetService.getBudgetsByName" [createData]="budgetService.createBudget" [updateData]="budgetService.updateBudget"
    [deleteData]="budgetService.deleteBudget" [user_id]="orderId" [formTemplate]="formTmpl" pertinence="subsection"
    section="budget" subsection="budget" icon="assets/ico/budget.svg"
    header="{{'order.budget.title' | translate | titlecase}}" [openedId]="openedId"
    (newProjectEvent)="newProject($event)" (newBudgetFillEmmiter)="budgetFill($event)"
    rightIcon="assets/ico/chart-pie.svg" (rightIconEvent)="budgetSummaryOpen()">
</apc-multi-forms>

<ng-template #formTmpl let-data>
    <form [formGroup]="data">
        <div class="container-fluid">
            <div class="row mb-3">
                <div class="form-group col-lg">
                    <label>{{'order.budget.code' | translate}}</label>
                    <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="code"
                        [type]="'text'">
                    </apc-form-input>
                </div>
                <div class="form-group col-lg">
                    <label>{{'order.budget.name' | translate}} *</label>
                    <apc-form-input [enabledFocus]="true" [class]="'form-control'" formControlName="name" [type]="'text'">
                    </apc-form-input>
                </div>
            </div>
            <div class="row mb-3">
                <div class="form-group col-lg">
                    <label>{{'order.type' | translate}} *</label>
                    <apc-form-select formControlName="type" [items]="type" (isOpen)="fetchType()"
                        [loading]="typeLoading" [activeDescToltip]="true">
                    </apc-form-select>
                </div>
                <div class="form-group col-lg">
                    <label>{{'order.department' | translate}}</label>
                    <apc-form-select formControlName="department" [items]="department"
                        (isOpen)="fetchDepartment()" [loading]="departmentLoading"
                        [isObject]="true">
                    </apc-form-select>
                </div>
                <div class="form-group col-lg">
                    <label>{{'order.budget.jobCode' | translate}}</label>
                    <apc-form-input [class]="'form-control'" formControlName="jobCode" [type]="'text'">
                    </apc-form-input>
                </div>
            </div>
            <div class="row mb-3">
                <div class="form-group col-lg">
                    <label>{{'order.budget.description' | translate}}</label>
                    <apc-form-input [class]="'form-control mb-3'" formControlName="description" [type]="'textarea'"
                        [rows]="data.controls.descriptionRows.value">
                    </apc-form-input>
                </div>
            </div>
            <div class="row mb-5">
                <div class="form-group col-lg">
                    <label>{{'order.tags' | translate}}</label>
                    <tag-input formControlName="tags" [modelAsStrings]="true"
                        [onAdding]="transform" (onAdd)="data.markAsDirty()" (onRemove)="form.markAsDirty()"
                        [onlyFromAutocomplete]="false" [allowDupes]="false" [disable]="!data.editForm">
                        <tag-input-dropdown [showDropdownIfEmpty]="false" [autocompleteObservable]="getTags">
                        </tag-input-dropdown>
                    </tag-input>
                </div>
            </div>

            <div class="apc-form-card"
                *ngIf="data.controls.budgetProducts.value && data.controls.budgetProducts.value.length > 0"
                [ngClass]="data.editForm ? 'hide-products' : ''">
                <span class="title">{{'order.product.title' | translate}}</span>
                <div class="container-fluid my-2">

                    <div class="row mb-3 mt-3" style="display: contents;">
                    </div>
                    <div class="row mt-2 mb-2" style="display: contents;"
                        *ngFor="let product of  sortProducts(data.controls.budgetProducts.value) let i = index">
                        <njo-budget-product [product]="product" [isEdit]="data.editForm"
                            [budgetId]="data.value.identifier" style="width: 100%;" [orderId]="orderId"
                            [budgetForm]="data" (updateData)="updateData()"
                            (clearProducts)="clearProducts($event)"></njo-budget-product>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>